// import config from './authAbout/auth.config'

/**
 * @Author : ShaJiaJing
 * @Date : 2019/5/29
 * @Version : 1.0
 * @Content : 网址配置
 */
const mode = process.env.VUE_APP_CURRENTMODE
let baseUrl = ''
// let consoleUrl = ''
// let adminUrl = ''
// let developUrl = ''
switch (mode) {
  case 'development':
    baseUrl = 'http://127.0.0.1:8111'
    break
  case 'testing':
    baseUrl = 'https://192.168.0.14'
    break
  case 'preview204':
    baseUrl = 'https://192.168.0.204'
    break
  case 'uat':
    baseUrl = 'https://rpa.i-search.com.cn'
    break
  case 'production':
    baseUrl = 'https://rpa.i-search.com.cn'
    break
}

export default {
  baseUrl
}
